import React, { Component } from 'react';
import Wrapper from '../common/Wrapper';
import RoomsAndStudents from '../RoomsAndStudents';
import { MenuItem} from 'react-bootstrap'
import history from '../../history';
import PropTypes from 'prop-types'
import { routesUrls } from '../../settings/routes';
import Quiz from '../Quiz/Quiz';

class CustomItems extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  render() {
    const {formatMessage} = this.context;
    return <React.Fragment>
      <MenuItem
        onClick={() => {
          history.push(routesUrls.dashboard)
        }}
      >{formatMessage('navTitleDashboard')}</MenuItem>
      <MenuItem
        onClick={() => {
          history.push(routesUrls.quizs)
        }}
      >{formatMessage('dashStudentsTitle')}</MenuItem>
   </React.Fragment>
  }
}

const QuizPage = () => {
  return <Wrapper 
    renderButtonNav = {false}
    CustomItems={CustomItems}
  >
    <Quiz />
  </Wrapper>
}

export default QuizPage;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/QuizPage.js